module.exports = __webpack_public_path__ + "static/media/galerija_2016 (9).29c8a098.jpg";